import { api } from "@/lib/api";

export async function uploadFile(kind, file) {
  const fd = new FormData();
  fd.append("kind", kind);
  fd.append("file", file);
  const { data } = await api.post("/files", fd, { timeout: 120000 });
  return data.id;
}

export async function uploadVideo(file, onProgress = () => {}) {
  if (file.size > 100 * 1024 * 1024) throw new Error("Vidéo trop lourde (100 Mo maximum).");
  const { data } = await api.post("/files/chunked", { kind: "video", filename: file.name, content_type: file.type || "video/mp4", size: file.size });
  let offset = 0;
  while (offset < file.size) {
    const part = file.slice(offset, offset + data.chunk_size);
    const res = await api.put(`/files/chunked/${data.upload_id}`, part, { params: { offset }, headers: { "Content-Type": "application/octet-stream" }, timeout: 120000 });
    offset = res.data.received;
    onProgress(Math.round((offset / file.size) * 100));
  }
  const done = await api.post(`/files/chunked/${data.upload_id}/complete`);
  return done.data.id;
}

export async function fileUrl(id) {
  const { data } = await api.get(`/files/${id}/url`);
  return `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
}

export const deviceName = () => {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad/i.test(ua)) return "iPhone";
  return "Navigateur web";
};
